import { Helmet, HelmetProvider } from 'react-helmet-async';
import { FaPiggyBank, FaUniversity, FaBuilding } from 'react-icons/fa';
import './financa.css';
import investimentoImg1 from '../../assets/finance-7056936_1280.png';
import investimentoImg2 from '../../assets/growth-7558931_1920.jpg';

function Financa() {
    return (
        <HelmetProvider >
            <Helmet>
                <title>Planejamento Financeiro - Organize Suas Finanças</title>
                <meta name="description" content="Aprenda como organizar suas finanças com dicas sobre reserva de emergência, investimentos e aposentadoria." />
                <meta name="keywords" content="planejamento financeiro, finanças pessoais, reserva de emergência, investimentos, aposentadoria, Tesouro Direto, CDB, LCI, LCA" />
                <meta name="author" content="Felipe de Quadros Gomes" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Planejamento Financeiro - Organize Suas Finanças" />
                <meta property="og:description" content="Aprenda como organizar suas finanças com dicas sobre reserva de emergência, investimentos e aposentadoria." />
                <meta property="og:url" content="https://guiafinanceiro.vercel.app/financas" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Planejamento Financeiro - Organize Suas Finanças" />
                <meta name="twitter:description" content="Aprenda como organizar suas finanças com dicas sobre reserva de emergência, investimentos e aposentadoria." />

            </Helmet>
            <div className='controle_div'>
                <main className="containeris">
                    <header className="hero">
                        <div className="div_containeris">
                            <h1 className="h11">Planejamento Financeiro</h1>
                            <p>E você chegou até aqui, provavelmente está buscando organizar melhor sua vida financeira.
                                E você não está sozinho - segundo dados do Banco Central,
                                mais de 60% dos brasileiros sentem dificuldade em planejar suas finanças.
                                Mas calma, vou te mostrar que isso pode ser mais simples do que parece.</p>
                        </div>
                        
                    </header>

                    <section className="card-grid">
                        <div className="card">
                            <h3 className="h33">Primeiros Passos</h3>
                            <p className="p">Antes de falarmos sobre investimentos, precisamos construir uma base sólida.
                                Pense em suas finanças como uma casa - não adianta querer decorar o quarto se o alicerce está comprometido, certo?
                                O primeiro passo é entender seus números atuais. Pegue um café, abra uma planilha (ou mesmo um caderno)
                                e liste todas suas receitas e despesas mensais.
                                Parece básico, mas é surpreendente como esse simples exercício já traz revelações importantes.</p>
                        </div>
                        <div className="card">
                            <h3 className="h33">Reserva de Emergência</h3>
                            <p>Imagine acordar um dia e descobrir que seu carro precisa de um reparo urgente.
                                Sem uma reserva de emergência, esse tipo de situação pode virar uma bola de neve financeira.
                                Por isso, antes de pensar em investimentos mais sofisticados,
                                foque em guardar pelo menos 6 meses de suas despesas mensais.Uma reserva de emergência é como um amortecedor financeiro -
                                ela absorve os impactos de despesas inesperadas sem comprometer seu orçamento.</p>
                        </div>
                        <div className="card">
                            <h3 className="h33">Investimentos</h3>
                            <p className="p">Agora que você já tem sua reserva, vamos falar sobre como fazer seu dinheiro trabalhar para você.
                                A renda fixa é como aquele primeiro emprego - não é o mais emocionante do mundo,
                                mas te dá experiência e segurança para crescer.</p>
                        </div>

                        <div className="card">
                            <h3 className="h33">Tesouro Direto: O Primeiro Passo</h3>
                            <p className="p">É como começar a dirigir com um carro automático - mais simples e seguro.
                                O Tesouro Direto é um investimento do governo federal que oferece diferentes opções:</p>

                            <p className="p"><strong>Tesouro Selic:</strong>Ideal para reserva de emergência, pois acompanha a taxa Selic e tem liquidez diária.</p>
                            <p className="p"> <strong>Tesouro IPCA+</strong>Bom para objetivos de longo prazo, pois protege contra a inflação.</p>
                            <p className="p"><strong>Tesouro Prefixado:</strong>Para quem quer saber exatamente quanto vai receber no vencimento, pois tem uma taxa de retorno fixa.</p>

                        </div>

                        <div className="card">
                            <h3 className="h33">CDBs, LCIs e LCAs: Expandindo Horizontes</h3>
                            <p className="p">Estes investimentos são como diferentes sabores do mesmo sorvete - cada um com suas características,
                                mas todos seguros e regulamentados.
                                A principal diferença? LCIs e LCAs são isentas de imposto de renda,
                                enquanto CDBs pagam imposto mas costumam oferecer rendimentos um pouco maiores.</p>
                        </div>

                        <div className="card">
                            <h3 className="h33">Planejando sua Aposentadoria: Comece Hoje</h3>
                            <p className="p">Sei que aposentadoria pode parecer um assunto distante, principalmente se você é jovem.
                                Mas vou te contar um segredo: tempo é o ingrediente mais valioso nessa receita.
                                Vamos fazer uma conta simples: investindo R$ 500 por mês, com um rendimento médio de 8% ao ano, em 30 anos você teria aproximadamente R$ 750 mil.
                                Agora, se começar 10 anos depois, precisaria investir R$ 1.100 por mês para chegar no mesmo valor.
                                Ou seja, quanto mais cedo você começar, melhor.</p>
                        </div>

                        <div className="card">
                            <h3 className="h33">Dicas Práticas para Começar Hoje</h3>
                            <p className="p"><strong>Comece pequeno, mas comece:</strong>Não espere ter muito dinheiro para começar a investir. O importante é começar, mesmo que seja com pouco.</p>
                            <p className="p"><strong>Automatize seus investimentos mensais</strong>Configure transferências automáticas para suas contas de investimento.</p>
                            <p className="p"><strong>Estude antes de investir:</strong>Conhecimento é poder. Leia livros, faça cursos e aprenda sobre os diferentes tipos de investimentos.</p>
                            <p className="p"><strong> Diversifique gradualmente:</strong>Não coloque todos os seus ovos em uma cesta. Distribua seus investimentos em diferentes tipos de ativos para reduzir riscos.</p>
                        </div>
                    </section>

                    <section className="features">
                        <h2 className="h22">Investimentos em Renda Fixa E significados</h2>
                        <div className="investment-content">
                            <img src={investimentoImg1} alt="regando dinheiro metafora" className="investment-img" />
                            <img src={investimentoImg2} alt="grafico bolsa de valores" className="investment-img" />
                            <div className="investment-grid">
                                <div className="investment-item">
                                    <h3 className="h33"><FaPiggyBank className="icon" /> <strong>Tesouro Direto</strong></h3>
                                    <p className="p">Investimento seguro e garantido pelo governo federal.</p>
                                </div>
                                <div className="investment-item">
                                    <h3 className="h33"><FaUniversity className="icon" /> <strong>CDB</strong></h3>
                                    <p className="p">Certificados de depósito bancário com boas rentabilidades.</p>
                                </div>
                                <div className="investment-item">
                                    <h3 className="h33"><FaBuilding className="icon" /> <strong>LCI e LCA</strong></h3>
                                    <p className="p">Investimentos isentos de imposto de renda, focados em setores específicos como imobiliário e agronegócio.</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="cta">
                        <div className="cta_container">
                            <h4 className="h44">Comece Sua Jornada Financeira</h4>
                            <span className="spann">Planejamento financeiro não precisa ser complicado.
                                O segredo é começar com o básico e ir evoluindo conforme seu conhecimento e confiança aumentam.
                                O importante é ter disciplina e consistência. A cada mês, revise seu orçamento, analise seus investimentos e faça ajustes conforme necessário.
                                Com o tempo, você verá que suas finanças estarão mais organizadas e seu futuro financeiro mais seguro.

                                Lembre-se, o objetivo do planejamento financeiro é permitir que você viva uma vida tranquila, sabendo que está preparado para o futuro.
                                Comece sua jornada financeira agora e construa um futuro próspero e seguro para você e sua família.
                            </span>
                        </div>
                    </section>
                </main >
            </div>
        </HelmetProvider>
    );
};

export default Financa;
